import React, { useState, useEffect } from "react";
import products from "./products";
import { Link } from "react-router-dom";

const galleryImages = ["/images/home-screen-01.png", "/images/home-screen-02.png"];
const categories = ["All", "Math", "Science", "Space", "Chess", "Technology"];

function Home() {
  const [currentImage, setCurrentImage] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % galleryImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const filteredProducts =
    selectedCategory === "All"
      ? products
      : products.filter(
          (product) =>
            product.category.toLowerCase() === selectedCategory.toLowerCase()
        );

  return (
    <>
      {/* Slideshow */}
      <div style={{ width: "100%", overflow: "hidden" }}>
        <img
          src={galleryImages[currentImage]}
          alt="Slideshow"
          style={{
            width: "100%",
            maxHeight: "400px",
            objectFit: "cover",
            display: "block",
          }}
        />
      </div>

      <div style={{ height: "2rem" }}></div>

      {/* Filter Bar */}
      <div
        style={{
          backgroundColor: "#eee",
          padding: "1rem",
          display: "flex",
          justifyContent: "center",
          gap: "2rem",
          fontWeight: "bold",
          fontSize: "1rem",
          width: "100%",
        }}
      >
        {categories.map((cat) => (
          <span
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            style={{
              cursor: "pointer",
              userSelect: "none",
              padding: "0.5rem 1rem",
              borderRadius: "6px",
              backgroundColor: selectedCategory === cat ? "#ccc" : "transparent",
              transition: "background-color 0.3s",
            }}
          >
            {cat}
          </span>
        ))}
      </div>

      {/* Product Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "2rem",
          padding: "2rem",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {filteredProducts.map((product) => (
          <div key={product.id} style={{ textAlign: "center" }}>
            <Link
              to={`/product/${product.id}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={product.images[0]}
                alt={product.name}
                style={{ maxWidth: "100%", height: "auto", marginBottom: "1rem" }}
              />
              <h2>{product.name}</h2>
              <p>
                <i>£{product.price.toFixed(2)}</i>
              </p>
              <p style={{ fontSize: "0.8rem", color: "#777" }}>{product.category}</p>
            </Link>
          </div>
        ))}
      </div>
    </>
  );
}

export default Home;